// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';

import Alert from '@cloudscape-design/components/alert';

export const Info = () => (
  <Alert statusIconAriaLabel="Info">This page illustrates the use of the one-click delete pattern.</Alert>
);
